import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import cx from 'classnames';

import SVGIcon from '@arrive/svg-icon';
import LOCK from '@arrive/ui-icons/svg/ic_lock.svg'

import styles from './BookingModal.scss'


const isMinusTime = (timeNumber: number) => {
  return !!timeNumber && timeNumber < 0;
}
const calculateEndTime = (startTime: string, lockDuration: number) => {
  return moment(startTime).add(lockDuration, 's');
}

export default function BookingTimer({ lockStartTime, setLockExpired, lockDuration }: { lockStartTime: string; setLockExpired: () => void; lockDuration: number; }) {
  const calculateTimeRemaining = useCallback(() => {
    const endTimeMoment = calculateEndTime(lockStartTime, lockDuration);
    const timeRemainingDiff = endTimeMoment.diff(new Date());
    const duration = moment.duration(timeRemainingDiff);
    return duration;
  }, [lockStartTime]) //eslint-disable-line

  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());

  const [timePercentage, setTimePercentage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const nextTimeRemaining = calculateTimeRemaining();
      const timePercentageRemaining = 100 * (nextTimeRemaining.asSeconds() / lockDuration);
      setTimeRemaining(nextTimeRemaining);
      setTimePercentage(100 - timePercentageRemaining);
    }, 1000);

    return () => {
      clearInterval(timer);
    }
    //disabled line below because including lockDuration in the depenency array was updating the time percentage unwantedly.
  }, [calculateTimeRemaining, setLockExpired]); //eslint-disable-line

  useEffect(() => {
    if (timeRemaining.minutes() === 0 && timeRemaining.seconds() === 0) {
      setLockExpired();
    }
  }, [timeRemaining, setLockExpired])

  return (
    <div className={styles.progressContainer}>
      <div className={cx(styles.timerBar, { [styles.dangerBar]: !timeRemaining.minutes() || isMinusTime(timeRemaining.minutes()) })} style={{ width: `${timePercentage}%` }} />
      <div className={styles.timerSection} data-testid='booking-timer'>
        <SVGIcon svgRef={LOCK} className={styles.lockIcon} />
        You have <span className={styles.timerReadback}>{!!timeRemaining.minutes() && !isMinusTime(timeRemaining.minutes()) && `${timeRemaining.minutes()} min`} {(!isMinusTime(timeRemaining.seconds()) && timeRemaining.seconds()) || '0'} sec</span> to book this load
      </div>
    </div>
  )
}
